import React from "react";
import "./dashboardnotice.scss";
import useTheme from "../../components/useTheme/useTheme";
const DashboardNoticeCard = ({ notice }) => {
  const {theme} = useTheme()
  return (
    <>
      <div className="notice_card" style={{ cursor: "default" }}>
        {/* <h2 className="heading">{title}</h2> */}
        <p className={`desc ${theme === "light" && "text-black"}`}style={{ cursor: "default" }}>
          {notice}
        </p>
      </div>
    </>
  );
};

export default DashboardNoticeCard;
